export default "__VITE_ASSET__a31f9c37__"